import * as React from 'react';

export interface VideoContainerProps {
  vidSrc?: string;
  vidTitle?: string;
}

export const VideoContainer: React.FC<VideoContainerProps> = ({ vidSrc, vidTitle }) => {
  if (!vidSrc) return null;
  return (
    <div className="video-container" style={{ maxWidth: '600px', flexShrink: 0 }}>
      <iframe
        src={vidSrc}
        title={vidTitle}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
        style={{ width: '100%', height: '315px', borderRadius: '8px' }}
      ></iframe>
    </div>
  );
};
